import { ErrorHandling, FatalErrors, isWebGL2Supported, WebGL2Error } from "@classdojo/monsterverse-utils";

export function fatalErrorIfNoWebGL2() {
  if (!isWebGL2Supported()) {
    ErrorHandling.instance?.triggerFatalError(FatalErrors.NoWebGL2);
    throw new WebGL2Error();
  }
}
